import { makeStyles } from "@material-ui/core";


export default makeStyles((theme) => ({
  cameraAccess: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 12,
    boxShadow: "none",
    color: theme.palette.common.white,
    padding: "4px 12px",
    textAlign: "center",
    textTransform: "none",
  },
  listItem: {
    paddingTop: 16,
  },
  secondaryText: {
    display: "flex",
    color: theme.palette.grey[700],
  },
  viewOnly: {
    backgroundColor: theme.palette.grey[200],
    borderRadius: 12,
    boxShadow: "none",
    padding: "4px 12px",
    textAlign: "center",
    textTransform: "none",
  },
}));
